import { createApp } from "vue";
import "mosha-vue-toastify/dist/style.css";
import "./styles.css";
import "@fortawesome/fontawesome-free/js/all.js";

import router from "./router.js";
import api from "./plugins/api.js";
import utils from "./plugins/utils.js";
import i18n from "./plugins/i18n.js";
import amplitude from "./plugins/amplitude.js";
import App from "./App.vue";
import Icon from "./components/Icon.vue";
const app = createApp(App);

app.use(router);
app.use(api);
app.use(utils);
app.use(i18n);
app.use(amplitude);
app.component("icon", Icon);

app.mount("#app");
